class Range
{
    constructor(rangeElement)
    {
		this.range = rangeElement;
		
		let min = this.range.dataset.min * 1;
		let max = this.range.dataset.max * 1;
		this.sliderMin = min; // Slider minimum value
		this.sliderMax = max; // Slider maximum value

		this.initmin = this.range.dataset.initmin * 1;
		this.initmax = this.range.dataset.initmax * 1;

		this.minValue = min; // Initial min value
		this.maxValue = max; // Initial max value

		this.track = this.range.querySelector('.slider-track');
		this.thumbLeft = this.range.querySelector('.thumb-left');
		this.thumbRight = this.range.querySelector('.thumb-right');
		this.minValueField = this.range.querySelector('#min');
		this.maxValueField = this.range.querySelector('#max');

		this.init();
    }

    init()
	{
		// Initialize
		this.setupThumb(this.thumbLeft, true);
		this.setupThumb(this.thumbRight, false);
		this.updateSlider();

		if(this.initmin != "") {
			
			let delta = this.sliderMax - this.sliderMin; // 1857
			let px = this.initmin - this.sliderMin; 
			let leftPercent = (px / delta) * 100;
			let pxmax = this.initmax - this.sliderMin;
			let rightPercent = (pxmax / delta) * 100;
			this.minValue = this.initmin;
			this.maxValue = this.initmax;
			this.updateSlider({left:leftPercent, right:rightPercent});
		}
	}

	setupThumb(thumb, isLeftThumb)
	{
		thumb.addEventListener('mousedown', () =>
		{
			const onMouseMove = (e) => this.onDrag(e, isLeftThumb);
			const onMouseUp = () => {
				document.removeEventListener('mousemove', onMouseMove);
				document.removeEventListener('mouseup', onMouseUp);
			};
	
			document.addEventListener('mousemove', onMouseMove);
			document.addEventListener('mouseup', onMouseUp);
		});

		thumb.addEventListener('touchstart', () => {
			const onTouchMove = (e) => this.onDrag(e.touches[0], isLeftThumb);
			const onTouchEnd = () => {
				document.removeEventListener('touchmove', onTouchMove);
				document.removeEventListener('touchend', onTouchEnd);
			};
		
			document.addEventListener('touchmove', onTouchMove);
			document.addEventListener('touchend', onTouchEnd);
		});
	}

	updateSlider(p)
	{
		let range = this.sliderMax - this.sliderMin;
		let leftPercent = ((this.minValue - this.sliderMin) / range) * 100;
		let rightPercent = ((this.maxValue - this.sliderMin) / range) * 100;

		if(p != undefined) {
			leftPercent = p.left;
			rightPercent = p.right;
		}
		
		this.thumbLeft.style.left = `${leftPercent}%`;
		this.thumbRight.style.left = `${rightPercent}%`;
	
		this.track.style.setProperty('--left', `${leftPercent}%`);
		this.track.style.setProperty('--right', `${rightPercent}%`);
		this.track.style.background = `linear-gradient(
		to right,
		#ccd7de ${leftPercent}%,
		#003C65 ${leftPercent}%,
		#003C65 ${rightPercent}%,
		#ccd7de ${rightPercent}%
		)`;
	
		// Update displayed values
		this.minValueField.value = this.minValue + "$";
		this.maxValueField.value = this.maxValue + "$";
	}


	onDrag(e, isLeftThumb)
	{
		const rect = this.track.getBoundingClientRect();
		const trackWidth = rect.width;		
		const xPos = e.clientX - rect.left;

		let newValue = this.sliderMin + Math.round(((xPos / trackWidth) * (this.sliderMax - this.sliderMin)));

		if (isLeftThumb) {
			if (newValue < this.sliderMin) newValue = this.sliderMin;
			if (newValue >= this.maxValue) newValue = this.maxValue - 1;
			this.minValue = newValue;
		} else {
			if (newValue > this.sliderMax) newValue = this.sliderMax;
			if (newValue <= this.minValue) newValue = this.minValue + 1;
			this.maxValue = newValue;
		}

		this.updateSlider();
	}
}

export default Range;